import * as React from 'react';
import SvgYoutubeButton from '@bytebrand/fe-ui-core-autobahn/iconsvg/SVG/slider/YoutubeButton';
import { Image } from '@bytebrand/fe-ui-core-autobahn/compat';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import styles from './Slide.styl';
import i18next from 'i18next';
const t = (key, options) => i18next.t(key, options);
class Slide extends React.PureComponent {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "container", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "image", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isMouseDown", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "mouseDownPositionX", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "mouseDownPositionY", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "moveDeltaX", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "moveDeltaY", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "lastPositionX", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "lastPositionY", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "imageWidth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "imageHeight", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "containerWidth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "containerHeight", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "calculatePosition", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { currentX, currentY } = this.state;
                const maxLeftLimit = (this.imageWidth - this.containerWidth) / 2;
                const maxRightLimit = -(this.imageWidth - this.containerWidth) / 2;
                const maxTopLimit = (this.imageHeight - this.containerHeight) / 2;
                const maxBottomLimit = -(this.imageHeight - this.containerHeight) / 2;
                this.isMouseDown = false;
                this.lastPositionX = currentX;
                this.lastPositionY = currentY;
                if (this.imageWidth > this.containerWidth) {
                    if (currentX > maxLeftLimit) {
                        this.lastPositionX = maxLeftLimit;
                        this.setState({
                            currentX: maxLeftLimit
                        });
                    }
                    else if (currentX < maxRightLimit) {
                        this.lastPositionX = maxRightLimit;
                        this.setState({
                            currentX: maxRightLimit
                        });
                    }
                }
                if (this.imageHeight > this.containerHeight) {
                    if (currentY > maxTopLimit) {
                        this.lastPositionY = maxTopLimit;
                        this.setState({
                            currentY: maxTopLimit
                        });
                    }
                    else if (currentY < maxBottomLimit) {
                        this.lastPositionY = maxBottomLimit;
                        this.setState({
                            currentY: maxBottomLimit
                        });
                    }
                }
            }
        });
        Object.defineProperty(this, "handleMouseDown", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (e) => {
                this.isMouseDown = true;
                if (typeof e.touches === 'object') {
                    this.mouseDownPositionX = e.touches[0].clientX;
                    this.mouseDownPositionY = e.touches[0].clientY;
                }
                else {
                    this.mouseDownPositionX = e.clientX;
                    this.mouseDownPositionY = e.clientY;
                }
                this.moveDeltaX = 0;
                this.moveDeltaY = 0;
            }
        });
        Object.defineProperty(this, "handleMouseMove", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (e) => {
                const { scale } = this.props;
                let clientX = 0;
                let clientY = 0;
                if (typeof e.touches === 'object') {
                    clientX = e.touches[0].clientX;
                    clientY = e.touches[0].clientY;
                }
                else {
                    clientX = e.clientX;
                    clientY = e.clientY;
                }
                if (!this.isMouseDown) {
                    return false;
                }
                if (scale !== 1) {
                    this.moveDeltaX = clientX - this.mouseDownPositionX;
                    this.moveDeltaY = clientY - this.mouseDownPositionY;
                    const currentPositionX = this.lastPositionX + this.moveDeltaX;
                    const currentPositionY = this.lastPositionY + this.moveDeltaY;
                    const maxLeftLimit = (this.imageWidth - this.containerWidth) / 2;
                    const maxRightLimit = -(this.imageWidth - this.containerWidth) / 2;
                    const maxTopLimit = (this.imageHeight - this.containerHeight) / 2;
                    const maxBottomLimit = -(this.imageHeight - this.containerHeight) / 2;
                    if (this.imageWidth > this.containerWidth) {
                        if (currentPositionX > maxLeftLimit) {
                            this.lastPositionX = maxLeftLimit;
                            this.setState({
                                currentX: maxLeftLimit
                            });
                        }
                        else if (currentPositionX < maxRightLimit) {
                            this.lastPositionX = maxRightLimit;
                            this.setState({
                                currentX: maxRightLimit
                            });
                        }
                        else {
                            this.moveDeltaX = clientX - this.mouseDownPositionX;
                            this.setState({
                                currentX: currentPositionX
                            });
                        }
                    }
                    if (this.imageHeight > this.containerHeight) {
                        if (currentPositionY > maxTopLimit) {
                            this.lastPositionY = maxTopLimit;
                            this.setState({
                                currentY: maxTopLimit
                            });
                        }
                        else if (currentPositionY < maxBottomLimit) {
                            this.lastPositionY = maxBottomLimit;
                            this.setState({
                                currentY: maxBottomLimit
                            });
                        }
                        else {
                            this.moveDeltaY = clientY - this.mouseDownPositionY;
                            this.setState({
                                currentY: currentPositionY
                            });
                        }
                    }
                }
            }
        });
        this.container = React.createRef();
        this.image = React.createRef();
        this.state = {
            currentX: 0,
            currentY: 0
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { scale } = this.props;
        if (scale !== prevProps.scale) {
            if (scale === 1) {
                this.isMouseDown = false;
                this.mouseDownPositionX = 0;
                this.mouseDownPositionY = 0;
                this.moveDeltaX = 0;
                this.moveDeltaY = 0;
                this.lastPositionX = 0;
                this.lastPositionY = 0;
                this.containerWidth = 0;
                this.containerHeight = 0;
                this.imageWidth = 0;
                this.imageHeight = 0;
                this.setState({
                    currentX: 0,
                    currentY: 0
                });
            }
            else {
                this.containerWidth = this.container.current.getBoundingClientRect().width;
                this.containerHeight = this.container.current.getBoundingClientRect().height;
                this.imageWidth = this.image.current.image.current.getBoundingClientRect().width;
                this.imageHeight = this.image.current.image.current.getBoundingClientRect().height;
            }
            this.calculatePosition();
        }
    }
    render() {
        const { imageUrl, ratioW, ratioH, scale, imageProps, videoUrl, showYoutube, updateCookies } = this.props;
        const { currentX, currentY } = this.state;
        const paddingTop = `${100 * ratioH / ratioW}%`; // eslint-disable-line no-magic-numbers
        return (React.createElement("div", { className: styles.imageClass, style: { paddingTop }, ref: this.container },
            React.createElement("div", { className: styles.slide, onMouseDown: this.handleMouseDown, onTouchStart: this.handleMouseDown, onMouseUp: this.calculatePosition, onTouchEnd: this.calculatePosition, onMouseMove: this.handleMouseMove, onTouchMove: this.handleMouseMove, onMouseOut: this.calculatePosition, style: scale === 1 ? undefined : { transform: `translate3d(${currentX}px, ${currentY}px, 0) scale3d(${scale}, ${scale}, 1)` } },
                !videoUrl && React.createElement(Image, { ratioW,
                    ratioH,
                    width: '100%',
                    src: imageUrl,
                    className: styles.imageClass,
                    ref: this.image,
                    ...imageProps }),
                videoUrl && showYoutube && (React.createElement("iframe", { width: '100%', height: 'auto', src: videoUrl, title: 'YouTube Video', className: styles.frame })),
                videoUrl && !showYoutube && (React.createElement("div", { className: styles.noYoutubeWrapper },
                    React.createElement(SvgYoutubeButton, null),
                    React.createElement("span", { className: styles.youtubeCookiesText }, t('VehicleDetailsPage:youtube.acceptCookiesText')),
                    React.createElement("div", null,
                        React.createElement(Button, { variant: 'text', className: styles.btn, onClick: () => window.open('https://www.youtube.com/howyoutubeworks/our-commitments/protecting-user-data/', '_blank') }, t('VehicleDetailsPage:youtube.dataProtection')),
                        React.createElement(Button, { variant: 'filled', className: styles.btn, onClick: updateCookies }, t('VehicleDetailsPage:youtube.allow'))))))));
    }
}
export default Slide;
